import React from "react";
import { Box, IconButton, TextField } from "@mui/material";
import { Add, Remove } from "@mui/icons-material";
import { FormFieldProps } from "../../../utils/formFields";

const CounterField: React.FC<FormFieldProps> = ({
  id,
  value,
  onChange,
  onBlur,
  label,
  placeholder,
  isRounded,
  isNonMarginTop,
  onIncrement,
  onDecrement,
  maxValue,
  counterWidth,
  counterHeight,counterBox,counterSign,disabled
}) => {
  const normalizedValue = value ?? "";
  const numericValue = Number(value ?? 0);

  return (
    <Box display="flex" alignItems="center" sx={{ padding:counterBox?counterBox: "16px" }}>
      <IconButton
        onClick={onDecrement}
        disabled={numericValue <= 0 || disabled}
        sx={{
          border: "1px solid #086D6A",
          width: counterWidth ? counterWidth : "26px",
          height: counterHeight ? counterHeight : "26px",
          marginRight: "4px",
          "&:hover": {
            backgroundColor: "#086D6A", // Change this to your desired hover color
          },
        }}
      >
        <Remove
          sx={{
            width:counterSign?counterSign: "20px",
            fontWeight: 600,
            "&:hover": {
              color: "#fff", // Change this to your desired hover color
            },
          }}
        />
      </IconButton>
      <TextField
      disabled={disabled || false}
        id={id}
        value={normalizedValue}
        onChange={onChange}
        onBlur={onBlur}
        variant="outlined"
        placeholder={placeholder}
        // fullWidth
        InputProps={{
          sx: {
            ...(isRounded && { borderRadius: "50px" }),
            background: "#fff",
            padding: "0px",
            ...(isNonMarginTop && { marginTop: "0px" }),
            "& input": {
              padding: "10px", // Set padding for the input element
              width: "42px",
              height: "14px",
            },
          },
        }}
        inputProps={{
          style: {
            textAlign: "center", // Center the text
          },
        }}
      />
      <IconButton
        onClick={onIncrement}
        disabled={maxValue ? numericValue >= maxValue : false || disabled}
        sx={{
          border: "1px solid #086D6A",
          width: counterWidth ? counterWidth : "26px",
          height: counterHeight ? counterHeight : "26px",
          marginLeft: "4px",
          "&:hover": {
            backgroundColor: "#086D6A", // Change this to your desired hover color
          },
        }}
      >
        <Add
          sx={{
            width:counterSign?counterSign: "20px",
            fontWeight: 600,
            "&:hover": {
              color: "#fff", // Change this to your desired hover color
            },
          }}
        />
      </IconButton>
    </Box>
  );
};

export default CounterField;
